/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/17/2023
 */
import React, { useEffect, useState } from "react"
import labelsEN from "../../../locales/en/translation.json"
import ControlPanelItem from "./components/ControlPanelItem"
import "./styles/ControlPanel.scss"
import api from "../services/AuthApi"
import { Fade } from "@mui/material"
import "../../styleSheets/base/styles.scss"

import { ReactComponent as User } from "../../../resources/addUser.svg";
import { ReactComponent as Permission } from "../../../resources/permission.svg";
import { ReactComponent as Credential } from "../../../resources/credential.svg";
import { ReactComponent as Settings } from "../../../resources/settings.svg";

const ControlPanel = () => {
  const [isUserRestricted, setIsUserDataRestricted] = useState(null)
  const [isPermRestricted, setIsPermRestricted] = useState(null)
  const [isSettingsRestricted, setIsSettingsRestricted] = useState(null)

  const [isLoading, setIsLoading] = useState(true)

  const isUser = JSON.parse(sessionStorage.getItem("isUserRestricted"))
  const isPerm = JSON.parse(sessionStorage.getItem("isPermRestricted"))
  const isSettings = JSON.parse(sessionStorage.getItem("isSettingsRestricted"))

  useEffect(() => {
    setIsUserDataRestricted(isUser)
    setIsPermRestricted(isPerm)
    setIsSettingsRestricted(isSettings)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true)

        const getAppConfig = {
          headers: {
            "Sort-Order": "ASC",
            Action: "VAU",
          },
        }

        const apprvConfig = {
          headers: {
            Action: "VAPR",
            "Sort-Field": "roleId",
          },
        }

        const requests = [
          api.get("/users/0/1/userId", getAppConfig),
          api.get("/role/permissions", apprvConfig),
          api.get("/settings/0/1/settingId"),
        ]

        const responses = await Promise.allSettled(requests)
        handleResponses(responses)
      } catch (error) {
        setIsLoading(false)
        console.error("Error occurred:", error)
      }
    }

    if (isUser === null || isPerm === null || isSettings === null) {
      fetchData()
    } else {
      setIsLoading(false)
    }
  }, [])

  const handleResponses = (responses) => {
    responses.forEach((response, index) => {
      if (response.status === "fulfilled") {
        // Handle successful response
        setIsLoading(false)
        sessionStorage.setItem("isUserRestricted", false)
        sessionStorage.setItem("isPermRestricted", false)
        sessionStorage.setItem("isSettingsRestricted", false)
        setIsUserDataRestricted(false)
        setIsPermRestricted(false)
        setIsSettingsRestricted(false)
      } else if (response.status === "rejected") {
        handleRejectedResponse(response.reason)
      }
    })
  }

  const handleRejectedResponse = (error) => {
    setIsLoading(false)
    if (
      error?.response?.data?.description === "Access Denied" &&
      error?.response?.data?.response === "Unauthorized"
    ) {
      if (error.config.url.includes("/users/0/1/userId")) {
        sessionStorage.setItem("isUserRestricted", true)
        setIsUserDataRestricted(true)
      } else if (error.config.url.includes("/role/permissions")) {
        sessionStorage.setItem("isPermRestricted", true)
        setIsPermRestricted(true)
      } else if (error.config.url.includes("/settings/")) {
        sessionStorage.setItem("isSettingsRestricted", true)
        setIsSettingsRestricted(true)
      }
    } else {
      // Handle other errors
      console.error("Error occurred:", error)
    }
  }

  const items = [
    {
      id: 0,
      icon: <User />,
      action: labelsEN.app_controlpanel_menuItem_1,
      path: "/app/userAccounts",
      isRestricted: isUserRestricted,
    },
    {
      id: 1,
      icon: <Permission />,
      action: labelsEN.app_controlpanel_menuItem_2,
      path: "/app/userPermissions",
      isRestricted: isPermRestricted,
    },
    {
      id: 2,
      icon: <Credential />,
      action: labelsEN.app_controlpanel_menuItem_3,
      path: "/app/credentialManager",
      isRestricted: isUserRestricted,
    },
    // {
    //   id: 3,
    //   icon: <UserTracker />,
    //   action: labelsEN.app_controlpanel_menuItem_4,
    //   path: "",
    // },
    // {
    //   id: 4,
    //   icon: <Activity />,
    //   action: labelsEN.app_controlpanel_menuItem_5,
    //   path: "",
    // },
    // {
    //   id: 5,
    //   icon: <Audit />,
    //   action: labelsEN.app_controlpanel_menuItem_6,
    //   path: "",
    // },
    // {
    //   id: 6,
    //   icon: <Theme />,
    //   action: labelsEN.app_controlpanel_menuItem_7,
    //   path: "",
    // },
    {
      id: 7,
      icon: <Settings />,
      action: labelsEN.app_controlpanel_menuItem_8,
      path: "/app/advancedSettings",
      isRestricted: isSettingsRestricted,
    },
  ]

  return (
    <div className="controlPanelWrapper">
      <h1>{labelsEN.app_controlpanel_page_title}</h1>
      <Fade in={true} style={{ transformOrigin: "0 0 0" }} timeout={700}>
        <div className="card-deck">
          {items.map((item) => {
            return (
              <ControlPanelItem
                key={item.id}
                icon={item.icon}
                action={item.action}
                path={item.path}
                isRestricted={item.isRestricted}
                isLoading={isLoading}
              />
            )
          })}
        </div>
      </Fade>
    </div>
  )
}
export default ControlPanel
